<template>
  <div
    ref="promocodeInfoBanner"
    :class="{ 'is-visible': showBanner }"
    class="wrapper promocode-banner js-code-activated"
  >
    <span class="code-activated">
      <i class="s s-check s-s mr-2"></i>
      <span class="t-link-secondary"> {{ props.i18n.promocode_banner.banner }}</span>
    </span>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

import { currentDevice } from '../../../../core/utils/currentDevice'
import { FASTBOOKING_EVENTS, IBH_FASTBOOKING_EVENTS } from '../../../../shared/fastbooking/constants'

const promocodeInfoBanner = ref(null)
const showBanner = ref(false)

// --- PROPS & EMITS ---
const props = defineProps({
  i18n: {
    type: Object,
    default: () => {},
  },
})

onMounted(() => {
  if (!currentDevice.isMobile) {
    //show banner
    document.addEventListener(IBH_FASTBOOKING_EVENTS.SHOW_BANNER, () => {
      showBanner.value = true

      const fastbookingPanelsOffsetTop = promocodeInfoBanner.value.offsetHeight
      const setFastbookingPanelsOffsetTop = new CustomEvent(FASTBOOKING_EVENTS.SET_PANELS_OFFSET_TOP, {
        detail: {
          offsetTop: fastbookingPanelsOffsetTop,
        },
      })

      document.dispatchEvent(setFastbookingPanelsOffsetTop)

      setTimeout(() => {
        showBanner.value = false

        const removeFastbookingPanelsOffsetTop = new CustomEvent(FASTBOOKING_EVENTS.REMOVE_PANELS_OFFSET_TOP, {
          detail: {
            offsetTop: fastbookingPanelsOffsetTop,
          },
        })

        document.dispatchEvent(removeFastbookingPanelsOffsetTop)
      }, '10000')
    })

    //hide banner
    document.addEventListener(FASTBOOKING_EVENTS.RESET_PROMOCODE, () => {
      showBanner.value = false
    })
  }
})
</script>

<style lang="scss">
@use '../../../../base_css/abstracts/abstracts.scss' as *;

.promocode-banner {
  position: absolute;
  left: 0;
  right: 0;
  transform: translateY(-100%);
  opacity: 0;
  transition:
    transform 0.3s,
    opacity 0.3s;

  &.is-visible {
    position: relative;
    transform: translateY(0);
    opacity: 1;
  }

  .code-activated {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    margin: 0;
    border-right: 1px solid var(--c_green);
    border-bottom: 1px solid var(--c_green);
    border-left: 1px solid var(--c_green);
    background: var(--c_light_green);
    color: var(--c_green);
    text-transform: uppercase;
  }
}
</style>
